module.exports = __webpack_public_path__ + "img/75.8acec0a2.png";